'use client';

import { createContext, useContext } from 'react';

/**
 * Path tracing on the public draw: the team or match under the mouse, and a match the viewer
 * jumped to from a "Loser → …" link. Absent (null) outside PublicDrawView, so MatchCard stays inert.
 */
export interface DrawHighlightValue {
  team: string | null;
  match: string | null;
  /** Where the hovered match sends its winner / loser. */
  winnerTarget: string | null;
  loserTarget: string | null;
  /** The match a jump is heading for; `n` changes on every jump so a repeat still fires. */
  focus: { matchId: string; n: number } | null;
  hoverTeam: (playerId: string | null) => void;
  hoverMatch: (matchId: string | null) => void;
  jump: (matchId: string) => void;
}

export const DrawHighlightContext = createContext<DrawHighlightValue | null>(null);

export const useDrawHighlight = () => useContext(DrawHighlightContext);
